var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49671 16C8.19588 16 7.94373 15.8975 7.74027 15.6924C7.53681 15.4874 7.43508 15.235 7.43508 14.9351V9.06492H1.56492C1.26502 9.06492 1.01257 8.96209 0.807552 8.75644C0.602518 8.55079 0.5 8.29754 0.5 7.99671C0.5 7.69588 0.602518 7.44373 0.807552 7.24027C1.01257 7.03681 1.26502 6.93508 1.56492 6.93508H7.43508V1.06492C7.43508 0.765023 7.53791 0.512567 7.74356 0.307552C7.94921 0.102517 8.20246 0 8.50329 0C8.80412 0 9.05627 0.102517 9.25973 0.307552C9.46319 0.512567 9.56492 0.765023 9.56492 1.06492V6.93508H15.4351C15.735 6.93508 15.9874 7.03791 16.1924 7.24356C16.3975 7.44921 16.5 7.70246 16.5 8.00329C16.5 8.30412 16.3975 8.55627 16.1924 8.75973C15.9874 8.96319 15.735 9.06492 15.4351 9.06492H9.56492V14.9351C9.56492 15.235 9.46209 15.4874 9.25644 15.6924C9.05079 15.8975 8.79754 16 8.49671 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/createIcon.006770ac.svg";
export { ForwardRef as ReactComponent };